export default __webpack_public_path__ + "static/media/how-it-work2-blue.0084e34a.svg";